var abGlyphs = window.abGlyphs || ((t) => (/[\u0590-\u08ff\u0900-\u0dff\ufb1d-\ufefc]/.test(t) ? t.split(/(\s+)/).filter(Boolean) : [...t])); // shared by the MOGRT scripts, so a page loading two of them still runs both; joined scripts (Arabic, Hindi) animate by word so letters stay connected
/*
 * MOGRT controls bento (sections/mogrt-controls.liquid).
 *
 * Every tile is a still until it plays: on touch screens while it is in
 * view, with a mouse while it is hovered. Playing sets [data-play] on the
 * tile (CSS loops key off it) and runs the tile's scripted parts from one
 * requestAnimationFrame loop per section:
 *   [data-mc-cycle]    steps through looks (children, or data-on 0..n-1)
 *   [data-mc-count]    counts from start to end value, holds, again
 *   [data-mc-timing]   a counter whose clip gets shorter and longer
 *   [data-mc-clock]    a countdown from a few start times in turn
 *   [data-mc-ms]       a countdown with hundredths running
 *   [data-mc-split]    a title animating in by character, word, then line
 *   [data-mc-inout]    in one way, out another
 *   [data-mc-wiggle]   letters wiggling, one control going up and down
 * The hero's count ([data-mc-countup]) counts up once, the first time the
 * section comes into view. Off screen or in a hidden tab the section gets
 * [data-asleep] and the loop stops; with reduced motion nothing plays.
 */
(() => {
  const still = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mouse = window.matchMedia('(hover: hover) and (pointer: fine)');

  const clamp = (n, lo, hi) => Math.min(hi, Math.max(lo, n));
  const easeOut = (p) => 1 - Math.pow(1 - p, 3);
  const easeInOut = (p) => (p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
  const pad = (n) => String(n).padStart(2, '0');
  const group = (n, sep) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const clock = (secs) => {
    const s = Math.max(0, Math.ceil(secs - 1e-6));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    return (h ? pad(h) + ':' : '') + pad(m) + ':' + pad(s % 60);
  };

  /* ---------- the parts ---------- */

  // looks in turn: children marked [data-on], or data-on="i" on the element
  const cycle = (el) => {
    const byChildren = !el.dataset.n;
    const items = byChildren ? [...el.children] : [];
    const n = byChildren ? items.length : Number(el.dataset.n);
    const idle = Number(el.dataset.idle || 0);
    const every = Number(el.dataset.ms || 1500);
    const followers = el.parentElement ? [...el.parentElement.querySelectorAll('[data-mc-cycle-follow]')] : [];
    let i = idle;
    let t = 0;
    const show = (k) => {
      i = k;
      el.dataset.on = k;
      if (byChildren) items.forEach((c, j) => c.toggleAttribute('data-on', j === k));
      followers.forEach((f) => [...f.children].forEach((c, j) => c.toggleAttribute('data-on', j === k)));
    };
    return {
      start() { t = every - 450; },
      tick(dt) {
        t += dt;
        if (t >= every) { t = 0; show((i + 1) % n); }
      },
      stop() { show(idle); },
    };
  };

  // start value to end value, a hold, again
  const countUp = (el, tile) => {
    const from = Number(el.dataset.from || 0);
    const to = Number(el.dataset.to || 0);
    const sep = el.dataset.sep || '';
    const range = tile.querySelector('[data-mc-range]');
    const RUN = 1700;
    const HOLD = 1300;
    let t = 0;
    const draw = (p) => {
      el.textContent = group(from + (to - from) * easeOut(p), sep);
      if (range) range.style.setProperty('--p', p.toFixed(3));
    };
    return {
      start() { t = 0; draw(0); },
      tick(dt) {
        t = (t + dt) % (RUN + HOLD);
        draw(clamp(t / RUN, 0, 1));
      },
      stop() { draw(1); },
    };
  };

  // the same count on a short clip, then a long one: the clip sets the pace
  const timing = (el, tile) => {
    const to = Number(el.dataset.to || 0);
    const sep = el.dataset.sep || '';
    const bar = tile.querySelector('[data-mc-timing-bar]');
    const RUNS = [{ ms: 900, len: 0.36 }, { ms: 2300, len: 0.92 }];
    const HOLD = 900;
    let k = 0;
    let t = 0;
    const set = (len, head, value) => {
      bar.style.setProperty('--len', len);
      bar.style.setProperty('--head', head.toFixed(3));
      el.textContent = group(value, sep);
    };
    return {
      start() { k = 0; t = 0; set(RUNS[0].len, 0, 0); },
      tick(dt) {
        t += dt;
        const run = RUNS[k];
        if (t > run.ms + HOLD) { k = (k + 1) % RUNS.length; t = 0; }
        const r = RUNS[k];
        const p = clamp(t / r.ms, 0, 1);
        set(r.len, p, to * easeOut(p));
      },
      stop() {
        bar.style.removeProperty('--len');
        bar.style.removeProperty('--head');
        el.textContent = group(to, sep);
      },
    };
  };

  // a countdown from each start time in turn, a few seconds of each
  const startTimes = (el) => {
    const starts = (el.dataset.starts || '10').split(',').map(Number);
    const idle = Number(el.dataset.idle || 0);
    const text = el.querySelector('[data-mc-clock-text]');
    const EACH = 3200;
    let k = idle;
    let t = 0;
    const show = () => {
      el.dataset.on = k;
      text.textContent = clock(starts[k] - Math.floor(t / 1000));
    };
    return {
      start() { k = 0; t = 0; show(); },
      tick(dt) {
        t += dt;
        if (t >= EACH) { t = 0; k = (k + 1) % starts.length; }
        show();
      },
      stop() { k = idle; t = 0; show(); },
    };
  };

  // hundredths running down to zero, a beat, again
  const hundredths = (el) => {
    const from = Number(el.dataset.from || 10);
    const idleHtml = el.innerHTML;
    let t = 0;
    const draw = (left) => {
      const cs = Math.max(0, Math.floor(left * 100));
      const s = Math.floor(cs / 100);
      el.innerHTML = `${pad(Math.floor(s / 60))}:${pad(s % 60)}<span class="mc-ms__ms">.${pad(cs % 100)}</span>`;
    };
    return {
      start() { t = 0; },
      tick(dt) {
        t = (t + dt) % ((from + 0.8) * 1000);
        draw(from - t / 1000);
      },
      stop() { el.innerHTML = idleHtml; },
    };
  };

  // the words of a title in pieces (one per character), knowing their word and line
  const pieces = (el) => {
    const list = [];
    let w = 0;
    el.querySelectorAll('.mc-split__line').forEach((line, li) => {
      const words = line.textContent.trim().split(/\s+/);
      line.textContent = '';
      words.forEach((word, wi) => {
        if (wi) line.append(' ');
        const box = document.createElement('span');
        box.style.display = 'inline-block';
        abGlyphs(word).forEach((ch) => {
          const s = document.createElement('span');
          s.dataset.mcPiece = '';
          s.textContent = ch;
          box.append(s);
          list.push({ s, c: list.length, w, l: li });
        });
        line.append(box);
        w += 1;
      });
    });
    return list;
  };

  // stop any letter still easing in or out. A transition whose end value
  // does not change keeps running after the tile stops, so without this a
  // letter left mid-way stays shifted and blurred, and the next hover
  // starts from that half-finished state
  const settle = (list) => {
    list.forEach((p) => p.s.getAnimations().forEach((a) => a.cancel()));
  };

  const delays = (list, by, step, prop) => {
    list.forEach((p) => p.s.style.setProperty(prop, String((by === 0 ? p.c : by === 1 ? p.w : p.l) * step[by])));
  };

  // a timeline of steps (at ms) that loops; each step sets attributes
  const timeline = (el, steps, length, reset) => {
    let t = 0;
    let next = 0;
    return {
      start() { t = 0; next = 0; },
      tick(dt) {
        t += dt;
        while (next < steps.length && t >= steps[next][0]) { steps[next][1](); next += 1; }
        if (t >= length) { t = 0; next = 0; }
      },
      stop() { reset(); },
    };
  };

  // by character, by word, by line
  const split = (el) => {
    const list = pieces(el);
    const IN = [26, 95, 240];
    const OUT = [12, 50, 120];
    let mode = 0;
    const arm = (m) => {
      settle(list);
      mode = m;
      el.dataset.mode = m;
      el.removeAttribute('data-in');
      el.removeAttribute('data-out');
      el.setAttribute('data-armed', '');
      delays(list, m, IN, '--d');
      delays(list, m, OUT, '--o');
    };
    const steps = [];
    [0, 1, 2].forEach((m) => {
      const at = m * 2700;
      steps.push([at, () => arm(m)]);
      steps.push([at + 60, () => el.setAttribute('data-in', '')]);
      steps.push([at + 1950, () => el.setAttribute('data-out', '')]);
    });
    return timeline(el, steps, 8100, () => {
      settle(list);
      el.removeAttribute('data-armed');
      el.removeAttribute('data-in');
      el.removeAttribute('data-out');
      el.dataset.mode = 0;
      mode = 0;
    });
  };

  // in rises by character and leaves by word, then in by word from the
  // left and out by character upwards
  const inOut = (el) => {
    const list = pieces(el);
    const steps = [];
    const set = (combo) => {
      settle(list);
      el.dataset.combo = combo;
      el.removeAttribute('data-in');
      el.removeAttribute('data-out');
      el.setAttribute('data-armed', '');
      el.dataset.phase = 'in';
      delays(list, combo === 0 ? 0 : 1, [26, 110, 0], '--d');
      delays(list, combo === 0 ? 1 : 0, [14, 70, 0], '--o');
    };
    [0, 1].forEach((combo) => {
      const at = combo * 3000;
      steps.push([at, () => set(combo)]);
      steps.push([at + 60, () => el.setAttribute('data-in', '')]);
      steps.push([at + 2050, () => { el.dataset.phase = 'out'; el.setAttribute('data-out', ''); }]);
    });
    return timeline(el, steps, 6000, () => {
      settle(list);
      ['data-armed', 'data-in', 'data-out', 'data-phase'].forEach((a) => el.removeAttribute(a));
      el.dataset.combo = 0;
    });
  };

  // letters wiggling: a turn and a little lift each, wandering
  const hash = (n) => {
    const x = Math.sin(n * 127.1 + 311.7) * 43758.5453;
    return (x - Math.floor(x)) * 2 - 1;
  };
  const noise = (seed, x) => {
    const i = Math.floor(x);
    const f = x - i;
    const u = f * f * (3 - 2 * f);
    return hash(seed + i * 7.31) * (1 - u) + hash(seed + (i + 1) * 7.31) * u;
  };
  const FONTS = ['', 'Georgia, "Times New Roman", serif', 'ui-monospace, "SF Mono", Menlo, Consolas, monospace', 'ui-rounded, "SF Pro Rounded", "Arial Rounded MT Bold", sans-serif'];
  const PIVOTS = ['17%', '50%', '83%'];

  const wiggle = (el) => {
    const vary = el.dataset.vary || '';
    const word = el.querySelector('.mc-word');
    const slider = el.querySelector('[data-mc-slider]');
    const chars = [];
    const text = word.textContent;
    word.textContent = '';
    abGlyphs(text).forEach((ch) => {
      if (/\s/.test(ch)) return word.append(ch);
      const s = document.createElement('span');
      s.className = 'mc-wig__char';
      s.textContent = ch;
      word.append(s);
      chars.push(s);
    });
    const seed = 17.3;
    const base = { amount: vary === 'anchor' ? 1.7 : 1, rate: 2.4, corr: 0.15 };
    const now = { ...base, phase: 2.35 };
    const target = { ...base };
    const BEAT = 2300;
    let t = 0;
    let beat = 0;
    const ranges = {
      amount: [0.25, 1.9],
      speed: [0.9, 6.5],
      correlation: [0, 1],
    };
    const keyOf = { amount: 'amount', speed: 'rate', correlation: 'corr' };

    const pose = () => {
      const c = now.corr;
      const keep = 1 / Math.hypot(1 - c, c);
      const turnAll = noise(seed + 91.3, now.phase);
      const liftAll = noise(seed + 53.1, now.phase * 0.9);
      chars.forEach((ch, i) => {
        const turn = ((1 - c) * noise(seed + i * 3.7, now.phase) + c * turnAll) * keep;
        const lift = ((1 - c) * noise(seed + i * 3.7 + 1.9, now.phase * 0.9) + c * liftAll) * keep;
        ch.style.transform = `translateY(${(lift * 0.07 * now.amount).toFixed(3)}em) rotate(${(turn * 9 * now.amount).toFixed(2)}deg)`;
      });
      if (slider && ranges[vary]) {
        const [lo, hi] = ranges[vary];
        const v = (now[keyOf[vary]] - lo) / (hi - lo);
        slider.style.setProperty('--at', `${(12 + clamp(v, 0, 1) * 76).toFixed(1)}%`);
      }
    };

    // beat k: the control at its low or high end, or the next anchor / font
    const apply = (k) => {
      if (ranges[vary]) target[keyOf[vary]] = ranges[vary][k % 2 ? 1 : 0];
      if (vary === 'anchor') { el.dataset.on = k % 3; word.style.setProperty('--pivot', PIVOTS[k % 3]); }
      if (vary === 'font') { el.dataset.on = k % 4; word.style.fontFamily = FONTS[k % 4]; }
    };

    const rest = () => {
      Object.assign(now, base, { phase: 2.35 });
      Object.assign(target, base);
      if (vary === 'anchor') { el.dataset.on = 1; word.style.setProperty('--pivot', '50%'); }
      if (vary === 'font') { el.dataset.on = 0; word.style.fontFamily = ''; }
      pose();
    };
    rest();

    return {
      start() {
        t = 0;
        beat = vary === 'anchor' ? 0 : vary === 'font' ? 0 : 0;
        apply(beat);
      },
      tick(dt) {
        t += dt;
        if (t >= BEAT) { t = 0; beat += 1; apply(beat); }
        const ease = 1 - Math.exp(-dt / 260);
        now.amount += (target.amount - now.amount) * ease;
        now.rate += (target.rate - now.rate) * ease;
        now.corr += (target.corr - now.corr) * ease;
        now.phase += (dt / 1000) * now.rate;
        pose();
      },
      stop() { rest(); },
    };
  };

  /* ---------- a section ---------- */

  const init = (root) => {
    if (!root || root.dataset.mcReady) return;
    root.dataset.mcReady = '1';
    const calm = still.matches;

    const tiles = [...root.querySelectorAll('[data-mc-tile]')].map((tile) => {
      const parts = [];
      tile.querySelectorAll('[data-mc-cycle]').forEach((el) => parts.push(cycle(el)));
      tile.querySelectorAll('[data-mc-count]').forEach((el) => parts.push(countUp(el, tile)));
      tile.querySelectorAll('[data-mc-timing]').forEach((el) => parts.push(timing(el, tile)));
      tile.querySelectorAll('[data-mc-clock]').forEach((el) => parts.push(startTimes(el)));
      tile.querySelectorAll('[data-mc-ms]').forEach((el) => parts.push(hundredths(el)));
      tile.querySelectorAll('[data-mc-split]').forEach((el) => parts.push(split(el)));
      tile.querySelectorAll('[data-mc-inout]').forEach((el) => parts.push(inOut(el)));
      tile.querySelectorAll('[data-mc-wiggle]').forEach((el) => parts.push(wiggle(el)));
      return { tile, parts, playing: false, live: !!tile.querySelector('.mpc--live') };
    });

    let visible = false;
    let raf = 0;
    let last = 0;
    const awake = () => visible && !document.hidden;

    const frame = (now) => {
      raf = 0;
      const dt = last ? Math.min(64, now - last) : 16;
      last = now;
      let any = false;
      tiles.forEach((p) => {
        if (!p.playing) return;
        any = true;
        p.parts.forEach((part) => part.tick(dt));
      });
      if (any && awake()) raf = requestAnimationFrame(frame);
      else last = 0;
    };
    const kick = () => {
      if (!raf && awake()) { last = 0; raf = requestAnimationFrame(frame); }
    };

    const play = (p) => {
      if (calm || p.playing) return;
      p.playing = true;
      p.tile.setAttribute('data-play', '');
      if (p.live) p.tile.setAttribute('data-live', '');
      p.parts.forEach((part) => part.start());
      kick();
    };
    const stop = (p) => {
      if (!p.playing) return;
      p.playing = false;
      p.tile.removeAttribute('data-play');
      p.tile.removeAttribute('data-live');
      p.parts.forEach((part) => part.stop());
    };

    // the hero's count: from 0 once, the first time the grid is in view
    const counter = root.querySelector('[data-mc-countup]');
    let countFinal = null;
    let countParts = null;
    if (counter && !calm) {
      const m = counter.textContent.trim().match(/^(\D*)(\d+)(.*)$/);
      if (m) {
        countFinal = counter.textContent;
        countParts = [m[1], Number(m[2]), m[3]];
        counter.textContent = `${m[1]}0${m[3]}`;
      }
    }
    const runCount = () => {
      if (!countParts) return;
      const [pre, to, post] = countParts;
      const t0 = performance.now();
      const DUR = 1600;
      const step = (now) => {
        const p = clamp((now - t0) / DUR, 0, 1);
        counter.textContent = `${pre}${Math.round(to * (1 - Math.pow(1 - p, 4)))}${post}`;
        if (p < 1) requestAnimationFrame(step);
        else counter.textContent = countFinal;
      };
      requestAnimationFrame(step);
    };

    if (!calm) root.setAttribute('data-armed', '');

    const update = () => {
      root.toggleAttribute('data-asleep', !awake());
      if (awake()) kick();
    };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        update();
      }).observe(root);

      const grid = root.querySelector('.mc__grid') || root;
      const seen = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        seen.disconnect();
        root.setAttribute('data-seen', '');
        runCount();
      }, { threshold: 0.2 });
      seen.observe(grid);

      // touch: a tile plays while most of it is in view
      if (!mouse.matches && !calm) {
        const byTile = new Map(tiles.map((p) => [p.tile, p]));
        const io = new IntersectionObserver((entries) => {
          entries.forEach((e) => {
            const p = byTile.get(e.target);
            if (e.isIntersecting) play(p);
            else stop(p);
          });
        }, { threshold: 0.6 });
        tiles.forEach((p) => io.observe(p.tile));
      }
    } else {
      visible = true;
      if (countFinal) counter.textContent = countFinal;
    }

    // mouse: a tile plays while hovered
    if (mouse.matches && !calm) {
      tiles.forEach((p) => {
        p.tile.addEventListener('pointerenter', () => play(p));
        p.tile.addEventListener('pointerleave', () => stop(p));
      });
    }

    document.addEventListener('visibilitychange', update);
    update();
  };

  const boot = (scope) => (scope || document).querySelectorAll('[data-mogrt-controls]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
